import { Context } from 'chartjs-plugin-datalabels';
import {
	getFromSessionStorage,
	saveToSessionStorage,
	SessionStorageKeyTypes,
} from 'utils';
import {
	AlignTypes,
	IChartPoint,
	IXAxesMinMax,
	IPointWithAlign,
} from '../../models';
import { getPointsWithAlign } from './pointLabelPositionDefining';

export const getPointLabelDisplay = (
	minAndMaxTicksValues: IXAxesMinMax,
	chartData: IChartPoint[],
) => (context: Context) => {
	if (!context) return false;
	const pointData = context.dataset.data as IChartPoint[];
	const point = pointData?.[context.dataIndex];

	let align = AlignTypes.bottom;
	const savedPointsWithAlign: IPointWithAlign[] = getFromSessionStorage(
		SessionStorageKeyTypes.pointAligns,
	);
	if (!savedPointsWithAlign) {
		const pointsWithAlign = getPointsWithAlign(
			context,
			minAndMaxTicksValues,
			chartData,
		);
		saveToSessionStorage(SessionStorageKeyTypes.pointAligns, pointsWithAlign);
		align =
			pointsWithAlign.find(({ priority }) => point.priority === priority)
				?.align || AlignTypes.center;
	} else {
		const curAlign = savedPointsWithAlign.find(
			({ priority }) => priority === point.priority,
		)?.align;
		if (curAlign) {
			align = curAlign;
		}
	}
	saveToSessionStorage(SessionStorageKeyTypes.currentPointAlign, align);
	return align !== AlignTypes.center;
};

export const getPointLabelAlign = () => {
	return getFromSessionStorage(SessionStorageKeyTypes.currentPointAlign);
};
